import styled from 'styled-components';

export const MainContainer = styled.div`
  width: 100%;
  min-height: 100%;
  background-color: ${({ theme }) => theme.gray4};
  display: flex;
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding-bottom: 20px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    padding-top: 30px;
    padding-bottom: 20px;
  }
`;

export const TitleBar = styled.div`
  width: 100%;
  height: 79px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.white};
  background-color: ${({ theme }) => theme.dark};
  margin-bottom: 50px;
  text-transform: uppercase;
  font-size: ${({ theme }) => theme.h4}px;
  font-family: ${({ theme }) => theme.primaryFontBold};
`;

export const DocsSection = styled.div`
  margin-bottom: 80px;

  > h1 {
    text-align: center;
    margin-bottom: 16px;
  }
`;

export const GridContainer = styled.div`
  width: 100%;
  display: grid;
  justify-content: center;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  grid-template-columns: 1fr 1fr 1fr 1fr;

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    grid-template-columns: 1fr 1fr 1fr;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    grid-template-columns: 1fr;
  }
`;

export const TabBar = styled.div`
  display: flex;
  height: 50px;
  background-color: ${({ theme }) => theme.dark};
`;

export const Tab = styled.div`
  display: flex;
  width: 50%;
  color: ${({ theme }) => theme.white};
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.coral : theme.dark};
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
`;
